import FeatureCard2 from '../FeatureCard2'
import WebsiteLayout from '../../components/LandingPageWrapper'
import { ReviewData } from '../../constants/mockdata'
import ReviewCard from '../ReviewCard'
import ValueCard from '../ValueCard'
import { Link } from 'react-router-dom'
import { landingPageContent } from '../../constants/LandingPageContent'
import Carousel from '../../components/Carousel'
import SlideIn from "../../components/Animation'/Slidein"
import { useState } from 'react'
import WaitlistModal from '../../components/Modal/WaitListModdal'
import Metadata from '../../components/Metadata'
import { residentPwaLink } from '../../constants'

const LandingPage = () => {
  const [openModal, setOpenModal] = useState(false)

  const landingPageMetadata = {
    title: 'Safelto - Property Management Platform',
    description:
      'Safelto is a modern property management platform that helps residential communities manage guests, residents, staff, and properties efficiently. Secure and affordable community management solution.',
    keywords: [
      'Safelto',
      'property management',
      'community management',
      'guest management',
      'resident management',
    ],
    image: '/assets/images/safelto-big.png',
    url: 'https://safelto.com',
    type: 'website' as 'website',
  }

  return (
    <WebsiteLayout>
      <Metadata {...landingPageMetadata} />
      <WaitlistModal open={openModal} onClose={() => setOpenModal(false)} />
      <div>
        <div className="text-center px-4 py-16">
          <div className="space-y-2">
            <p className="text-[#0853E4] text-2xl md:font-medium">
              {' '}
              {landingPageContent.heroSection.subtitle}
            </p>
            <p className="text-black dark:text-gray-300 text-3xl font-medium ">
              {landingPageContent.heroSection.title}
            </p>
            <p className="text-gray-600 dark:text-gray-300  max-w-2xl mx-auto">
              {landingPageContent.heroSection.description}
            </p>
          </div>

          {/* Download App Section */}
          <div className="items-center w-full gap-4 text-white text-xs mt-3 md:text-lg font-medium sm:items-start md:mt-10 my-5">
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">
              {/* <button className="inline-block w-[264px] h-[52px] bg-black dark:bg-gray-100 border border-gray-300 dark:border-black text-white dark:text-black py-3 px-6 rounded-lg text-lg text-center font-medium hover:bg-gray-700 dark:hover:bg-gray-300">
                {landingPageContent.heroSection.ctaButtons.download}
              </button> */}
              <a
                href={residentPwaLink()}
                className="inline-flex items-center justify-center min-w-[264px] whitespace-nowrap h-[52px] bg-black dark:bg-gray-100 border border-black dark:border-gray-100 text-white dark:text-black px-6 rounded-lg text-base md:text-lg font-medium hover:bg-gray-800 dark:hover:bg-gray-300"
              >
                {landingPageContent.heroSection.ctaButtons.resident}
              </a>
              <button
                onClick={() => setOpenModal(true)}
                className="inline-flex items-center justify-center min-w-[264px] whitespace-nowrap h-[52px] bg-white dark:bg-black border border-gray-300 dark:border-gray-600 text-black dark:text-gray-300 px-6 rounded-lg text-base md:text-lg font-medium hover:bg-gray-100 dark:hover:bg-gray-900"
              >
                {landingPageContent.heroSection.ctaButtons.download}
              </button>
            </div>
            <p className="mt-4 text-sm font-normal text-gray-600 dark:text-gray-400">
              {landingPageContent.heroSection.ctaButtons.residentNote}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-center">
          <img
            src="/assets/images/LandingPage_frame1.png"
            alt="landing-page"
            className=""
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
      </div>

      <div>
        <div className="max-w-screen-xl mx-auto text-center mt-10">
          <h2 className="text-black dark:text-gray-300 text-3xl font-medium mb-2 ">
            {landingPageContent.advantagesSection.title}
            <span className="text-[#0853E4] ml-2">
              {landingPageContent.advantagesSection.highlight}
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-300  mx-auto mb-5 md:w-[605px]">
            {landingPageContent.advantagesSection.description}
          </p>
          <div className="mt-6">
            <a
              href="/auth/register"
              className="inline-block w-[264px] h-[52px] bg-black dark:bg-gray-100 border border-gray-300 dark:border-black text-white dark:text-black py-3 px-6 rounded-lg text-lg text-center font-medium hover:bg-gray-700 dark:hover:bg-gray-300"
            >
              {landingPageContent.advantagesSection.cta}
            </a>
          </div>
        </div>

        <div className="flex items-center justify-center mt-14">
          <img
            src="/assets/images/landingpage_frame.png"
            alt="landing-page"
            className=""
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
      </div>

      <div>
        <div className="max-w-screen-xl mx-auto text-center space-y-2">
          <p className="text-[#0853E4] text-2xl md:font-medium">
            {landingPageContent.whyChooseUsSection.subtitle}
          </p>
          <p className="text-black dark:text-gray-300 text-3xl font-medium">
            {landingPageContent.whyChooseUsSection.title}{' '}
            {landingPageContent.whyChooseUsSection.estate}
          </p>
          <p className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            {landingPageContent.whyChooseUsSection.description}
          </p>
        </div>

        <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 mt-8 ">
          <ValueCard
            headerIcon="/assets/images/landingpage_group41.png"
            description="Enhanced security: Efficient and secure process for managing user access. The goal is to provide a hassle-free experience for guests and residents while ensuring the security and integrity of the premises."
          />
          <ValueCard
            headerIcon="/assets/images/landingpage_group42.png"
            description="Efficient staff and resident management: Streamlined processes and systems used to manage personnel and resident information, workflows and interactions within the estate."
          />
          <ValueCard
            headerIcon="/assets/images/landingpage_group43.png"
            description="Effective property management and listing: Our platform empowers residents to manage their properties, communicate with tenants, and easily list units for rent or sale—all in one place. Simple, smart, and built for your community."
          />
        </div>
      </div>

      <div>
        <div className="max-w-screen-xl mx-auto text-center space-y-2">
          <p className="text-[#0853E4] text-2xl md:font-medium">
            {landingPageContent.featuresSection.subtitle}
          </p>
          <p className="text-black dark:text-gray-300 text-3xl font-medium md:mx-5">
            {landingPageContent.featuresSection.title}
          </p>
          <p className="text-gray-500 dark:text-gray-300 max-w-2xl mx-auto">
            {landingPageContent.featuresSection.description}
          </p>
        </div>

        <div className="max-w-screen-xl mx-auto mt-20 space-y-20">
          <div className="flex flex-col md:flex-row md:items-center justify-between mx-4 gap-12 md:w-full">
            <div className=" w-fit md:w-1/2">
              <FeatureCard2
                headerIcon="Read more"
                headerText="Manage Guest"
                description={[
                  'Guest Information Management',
                  'Communication and Correspondence',
                  'Evaluation and Follow-up',
                ]}
              />
            </div>
            <img
              src="/assets/images/landingpage_frame1518.png"
              alt="landing-page"
              className="w-full md:w-1/2 rounded-lg object-contain"
            />
          </div>

          <SlideIn direction="right">
            <div className="flex flex-col-reverse md:flex-row items-center mx-4 gap-12 w-full">
              <img
                src="/assets/images/landingpage_frame1519.png"
                alt="landing-page"
                className="w-full md:w-1/2 rounded-lg object-contain"
              />
              <div className="w-full md:w-1/2">
                <FeatureCard2
                  headerIcon="Read more"
                  headerText="Advertise"
                  description={[
                    'Luxury Living Redefined',
                    'Find Your Dream Home',
                    'Experience Serenity',
                    'Invest in Your Future',
                  ]}
                />
              </div>
            </div>
          </SlideIn>
          <div className="flex flex-col md:flex-row md:items-center mx-4 gap-12">
            {/* <div></div> */}

            <FeatureCard2
              headerIcon="Read more"
              headerText="Maintenance Services"
              description="Our maintenance services improves productivity, enhances safety, meeting quality assurance standards. It brings about convenience and peace of mind and enhances residents' satisfactions."
            />
            <img
              src="/assets/images/landingpage_frame15201.png"
              alt="landing-page"
              className="w-full md:w-1/2 rounded-lg object-contain"
            />
          </div>
          <SlideIn direction="left">
            <div className="flex flex-col-reverse md:flex-row items-center mx-4 gap-12">
              <img
                src="/assets/images/landingpage_frame1521.png"
                alt="landing-page"
                className="w-full md:w-1/2 rounded-lg object-contain"
              />
              <div className="w-fit md:w-1/2 justify-center">
                <FeatureCard2
                  headerIcon="Read more"
                  headerText="Manage Resident’s Payment"
                  description="We ensure timely and accurate payments options."
                />
              </div>
            </div>
          </SlideIn>
        </div>
      </div>

      <div>
        <div className="max-w-screen-xl mx-auto text-center space-y-2">
          <p className="text-[#0853E4] text-base md:text-2xl md:font-medium font-normal">
            {landingPageContent.reviewSection.subtitle}
          </p>
          <p className="text-black dark:text-gray-300 text-[22px] md:text-3xl font-semibold md:mx-5">
            {landingPageContent.reviewSection.title}
          </p>
          <p className="text-gray-400 dark:text-gray-400 max-w-2xl mx-auto text-[13px] md:text-xl font-normal">
            {landingPageContent.reviewSection.description}
          </p>
        </div>

        <div className="max-w-screen-xl mx-auto mt-8">
          <div className="p-4">
            <Carousel
              slidesToShow={3}
              arrows={true}
              infinite={true}
              showDots={true}
              dotCenter={true}
              dotWidth="h-3 w-3"
            >
              {ReviewData.map((person, index) => (
                <ReviewCard key={index} {...person} />
              ))}
            </Carousel>
          </div>
        </div>
      </div>

      <div className="mx-auto w-full max-w-7xl min-h-[300px] bg-light-gradient dark:bg-dark-gradient rounded-lg p-6 sm:p-8 md:p-12 flex flex-col items-center justify-center text-center shadow-[0_8px_18px_-2px_rgba(0,0,0,0.70)] dark:shadow-[0_12px_28px_-2px_rgba(0,0,0,0.75)]">
        <h2 className="text-white text-3xl sm:text-4xl md:text-5xl leading-tight font-normal">
          {landingPageContent.finalCTA.title} <br />
          <span className="text-[#0853E4]">{landingPageContent.finalCTA.highlight}</span>
        </h2>
        <p className="text-[#D9D9D9] font-normal text-base sm:text-lg md:text-xl leading-relaxed max-w-2xl mt-6 mb-8">
          {landingPageContent.finalCTA.description}
        </p>
        <Link to="/auth/register">
          <button className="bg-gray-100 dark:bg-black text-black dark:text-gray-300 text-center py-3 px-6 rounded-lg text-lg md:text-base font-medium hover:bg-gray-300 dark:hover:bg-gray-700 transition-all">
            {landingPageContent.finalCTA.buttonText}
          </button>
        </Link>
      </div>
    </WebsiteLayout>
  )
}

export default LandingPage
